import { Alert } from '@/v2/plugins/alert';
import { api } from '@/v2/plugins/axios';
import { t } from '../../../../../locales';

export class WhatsAppMarketplace {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

    static async saveWhatsAppUsage(linkedMarketplaceId, data) {
        try {
            await api.post(`marketplace/save-whatsapp-usage/${linkedMarketplaceId}`, data);
        } catch (err) {
            const msg = err?.response?.data?.message;
            Alert.error(msg || t('Error Msg'));
            throw err;
        }
    }

    static async shareWhatsappCatalog(data) {
        try {
            await api.post(`/marketplace/share-whatsapp-catalog`, data);
        } catch (err) {
            const msg = err?.response?.data?.message;
            Alert.error(msg || t('Error Msg'));
            console.error(err);
            throw err;
        }
    }

}
